import { render, staticRenderFns } from "./bottomAlert.vue?vue&type=template&id=392bdb75&scoped=true"
import script from "./bottomAlert.vue?vue&type=script&lang=js"
export * from "./bottomAlert.vue?vue&type=script&lang=js"
import style0 from "./bottomAlert.vue?vue&type=style&index=0&id=392bdb75&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392bdb75",
  null
  
)

export default component.exports